module.exports = {
      id: "ic-calendar-usage",
      viewBox: "0 0 14 14",
      url: __webpack_public_path__ + "sprite-ad374a.smartcharts.svg#ic-calendar-usage",
      toString: function () {
        return this.url;
      }
    }